// extracted by mini-css-extract-plugin
module.exports = {"spinner":"SecondarySpinner_spinner__12wSr"};